const MATCH_NUMBERS_REGEX = /\d+/g;

export const getNumbersOnly = (value: string | null | undefined) =>
  value && value !== null ? value.match(MATCH_NUMBERS_REGEX)?.join('') : undefined;
